<template>
    <div 
        class="filter__container"
        :class="{'preloader-content': isPreloader}"
    >
        <div
            v-if="isPreloader"
            class="preloader fa fa-circle-o-notch fa-spin"
            :style="{top: `20%`}"
        >
        </div>
        <dropdown
            v-if="filterDataGroupingEntity !== null"
            title="Тип группировки"
            :items="filterDataGroupingEntity"
            :selectedItems="selectedFilterGroupingEntity"
            :isManyItems="false"
            :isSearch="false"
            :width="'220px'"
            :height="'44px'"
            @onChange="onChangeFilter($event[0], 'grouping_entity')"
        />
        <filter-control-datepicker
            v-if="Object.keys(filterDataDate).length !== 0"
            :items="filterDataDate"
            :selectedItems="selectedFilterDate"
            :width="'220px'"
            :height="'44px'"
            @onChange="onChangeFilter($event, 'date')"
        />
        <dropdown
            v-if="filterDataCity !== null"
            title="Города"
            :items="filterDataCity"
            :selectedItems="selectedFilterCity"
            :isManyItems="true"
            :isSearch="true"
            :width="'220px'"
            :height="'44px'"
            @onChange="onChangeFilter($event, 'city')"
        />
        <dropdown
            v-if="filterDataSlice !== null"
            title="Срезы"
            :items="filterDataSlice"
            :selectedItems="selectedFilterSlice"
            :isManyItems="false"
            :isSearch="false"
            :width="'220px'"
            :height="'44px'"
            @onChange="onChangeFilter($event[0], 'slice')"
        />
        <dropdown
            v-if="fillterDataFormat !== null"
            title="Формат"
            :items="fillterDataFormat"
            :selectedItems="selectedFilterFormat"
            :isManyItems="true"
            :isSearch="true"
            :width="'220px'"
            :height="'44px'"
            @onChange="onChangeFilter($event, 'format')"
        />
        <dropdown
            v-if="filterDataSupplyer !== null"
            title="Операторы"
            :items="filterDataSupplyer"
            :selectedItems="selectedFilterSupplyer"
            :isManyItems="true"
            :isSearch="true"
            :width="'220px'"
            :height="'44px'"
            @onChange="onChangeFilter($event, 'supplyer')"
        />
        <dropdown
            v-if="filterDataDirection !== null"
            title="Направления"
            :items="filterDataDirection"
            :selectedItems="selectedFilterDirection"
            :isManyItems="true"
            :isSearch="true"
            :width="'220px'"
            :height="'44px'"
            @onChange="onChangeFilter($event, 'direction')"
        />
        <dropdown
                v-if="filterDataClients !== null"
                title="Клиенты"
                :items="filterDataClients"
                :selectedItems="selectedFilterClients"
                :isManyItems="true"
                :isSearch="true"
                :width="'220px'"
                :height="'44px'"
                @onChange="onChangeFilter($event, 'client_id')"
        />
      <dropdown
          v-if="filterDataBrands !== null"
          title="Бренды"
          :items="filterDataBrands"
          :selectedItems="selectedFilterBrands"
          :isManyItems="true"
          :isSearch="true"
          :width="'220px'"
          :height="'44px'"
          @onChange="onChangeFilter($event, 'brand_id')"
      />
    </div>
</template>

<script>
import FilterControlDatepicker from './FilterControls/FilterControlDatepicker';
import Dropdown from '../Base/Dropdown';
export default {
    name: 'FilterContainer',
    components: {
        FilterControlDatepicker,
        Dropdown
    },
    /**
     * Входные данные компонента
     * @property {object} filterData - данные фильтра
     * @property {object} filterDataSelected - выбранные данные фильтра
     * @property {boolean} isPreloader - условие показа прелоадера
     */
    props: {
        filterData: {
            type: Object,
            default: () => ({})
        },
        filterDataSelected: {
            type: Object,
            default: () => ({})
        },
        isPreloader: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        /**
         * даты
         * @returns {object}
         */
        filterDataDate() {
            let {date = {}} = this.filterData;
            return date;
        },
        /**
         * города
         * @returns {object}
         */
        filterDataCity() {
            let {city = null} = this.filterData;
            return city;
        },
        /**
         * срезы
         * @returns {object}
         */
        filterDataSlice() {
            let {slice = null} = this.filterData;
            return slice;
        },
        /**
         * формат
         * @returns {object}
         */
        fillterDataFormat() {
            let {format = null} = this.filterData;
            return format;
        },
        /**
         * операторы
         * @returns {object}
         */
        filterDataSupplyer() {
            let {supplyer = null} = this.filterData;
            return supplyer;
        },
        /**
         * направления
         * @returns {object}
         */
        filterDataDirection() {
            let {direction = null} = this.filterData;
            return direction;
        },
        /**
         * клиенты
         * @returns {object}
         */
        filterDataClients() {
            let {client_id = null} = this.filterData;
            return client_id;
        },
      /**
       * бренды
       * @returns {object}
       */
      filterDataBrands() {
        let {brand_id = null} = this.filterData;
        return brand_id;
      },
      /**
       * группировка по брендам или клиентам
       * @returns {object}
       */
      filterDataGroupingEntity() {
        let {grouping_entity = null} = this.filterData;
        return grouping_entity;
      },
        /**
         * выбранные даты
         * @returns {array}
         */
        selectedFilterDate() {
            let {date = []} = this.filterDataSelected;
            let dateArr = (Array.isArray(date)) ? date : [date];
            let datesKeys = Object.keys(this.filterDataDate);
            let dateArrFiltered = dateArr.filter(date => datesKeys.includes(date));
            return dateArrFiltered;
        },
        /**
         * выбранные города
         * @returns {array}
         */
        selectedFilterCity() {
            let {city = []} = this.filterDataSelected;
            let cityArr = (Array.isArray(city)) ? city : [city];
            return cityArr;
        },
        /**
         * выбранные срезы
         * @returns {array}
         */
        selectedFilterSlice() {
            let {slice = []} = this.filterDataSelected;
            let sliceArr = (Array.isArray(slice)) ? slice : [slice];
            return sliceArr;
        },
        /**
         * выбранные форматы
         * @returns {array}
         */
        selectedFilterFormat() {
            let {format = []} = this.filterDataSelected;
            let formatArr = (Array.isArray(format)) ? format : [format];
            return formatArr;
        },
        /**
         * выбранные операторы
         * @returns {array}
         */
        selectedFilterSupplyer() {
            let {supplyer = []} = this.filterDataSelected;
            let supplyerArr = (Array.isArray(supplyer)) ? supplyer : [supplyer];
            return supplyerArr;
        },
        /**
         * выбранные направления
         * @returns {array}
         */
        selectedFilterDirection() {
            let {direction = []} = this.filterDataSelected;
            let directionArr = (Array.isArray(direction)) ? direction : [direction];
            return directionArr;
        },
        /**
         * выбранные клиенты
         * @returns {array}
         */
        selectedFilterClients() {
            let {client_id = []} = this.filterDataSelected;
            let clientArr = (Array.isArray(client_id)) ? client_id : [client_id];
            return clientArr;
        },
      /**
       * выбранные бренды
       * @returns {array}
       */
      selectedFilterBrands() {
        let {brand_id = []} = this.filterDataSelected;
        let brandArr = (Array.isArray(brand_id)) ? brand_id : [brand_id];
        return brandArr;
      },
      /**
       * выбранный тип группировки
       * @returns {array}
       */
      selectedFilterGroupingEntity() {
        let {grouping_entity = []} = this.filterDataSelected;
        let grEntityArr = (Array.isArray(grouping_entity)) ? grouping_entity : [grouping_entity];
        return grEntityArr;
      }
    },
    methods: {
        /**
         * изменить фильтр
         * @param {string} key - ключь в объекте
         * @param {array} data - данные
         */
        onChangeFilter(data, key) {
            let newFilterDataSelected = {
                ...this.filterDataSelected,
                [key]: data
            };
            this.$emit('onChangeFilter', newFilterDataSelected);
        }
    }
}
</script>

<style lang="scss" scoped>
    .filter__container {
        position: relative;
        display: flex;
        flex-wrap: wrap;

        margin-top: 10px;
        padding: 20px 25px;
        background: #fff;
        border-radius: 14px;
    }
</style>